import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { QUERY_KEY_MOVE_FILES_LIST } from "Data/keys/QueryKeys";
import { IMoveFileRequest } from "Data/interfaces/ListagemArquivos/IMoveFileRequest";
import { IUseQueryFilesReturn } from "Data/interfaces/ListagemArquivos/IListFiles";
import { ObrasApi } from "Data/Obras.api";
import { ListagemArquivosActions } from "Store/ListagemArquivos/ListagemArquivos.actions";
import { queryClient } from "Utils/queryClient";
import toastHandler from "Utils/toastHandler";

export const useQueryMoveFileMove = () => {
  const dispatch = useDispatch();

  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IMoveFileRequest) => {
      return ObrasApi.moveFile(variables);
    },
    onMutate: async (variables) => {
      const previousCurrentFolderList = queryClient.getQueryData<IUseQueryFilesReturn>(
        [QUERY_KEY_MOVE_FILES_LIST, Number(variables.ConstructionSiteId), variables.CurrentFolderId]
      );

      queryClient.setQueryData<IUseQueryFilesReturn>(
        [QUERY_KEY_MOVE_FILES_LIST, Number(variables.ConstructionSiteId), variables.CurrentFolderId],
        old => {
          if (old) {
            return {
              ...old,
              ListFiles: old.ListFiles.filter(file => !variables.FilesId.includes(file.Identifier.ApiId)),
            }
          }
          return old;
        }
      );

      return { previousCurrentFolderList };
    },
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MOVE_FILES_LIST, Number(variables.ConstructionSiteId), variables.NewFolderId],
        exact: true,
      });
      dispatch(ListagemArquivosActions.moveFileSuccess(variables));
    },
    onError: async (error: any, variables, context) => {
      await queryClient.cancelQueries({
        queryKey: [QUERY_KEY_MOVE_FILES_LIST, Number(variables.ConstructionSiteId), variables.CurrentFolderId],
        exact: true,
      });

      queryClient.setQueryData<IUseQueryFilesReturn>(
        [QUERY_KEY_MOVE_FILES_LIST, Number(variables.ConstructionSiteId), variables.CurrentFolderId],
        context?.previousCurrentFolderList
      );

      const msg = 'Erro ao mover arquivo';
      const errorMsg = error.errors ? error.errors[0]?.Message || msg : msg;
      dispatch(ListagemArquivosActions.moveFileFailure(errorMsg));
      toastHandler.showError(errorMsg);
    }
  });

  return {
    moveFile: mutate,
    isLoading: isPending,
  };
};
